import React, { useState } from "react";
import { Container, Box, Button } from "@mui/material";
import { Youtube } from "react-feather";
import { useTranslation } from "react-i18next";

const Video = ({ linkData = [] }) => {
  const [showIframe, setShowIframe] = useState(false);
  const { t } = useTranslation();

  const handleClick = () => {
    setShowIframe(true);
  };

  const handleClose = () => {
    setShowIframe(false);
  };

  const videoLink = linkData.length > 0 ? linkData[0].link : null;

  return (
    <Container maxWidth="lg" disableGutters>
      <Box
        sx={{
          height: 500,
          width: "100%",
          backgroundImage: "url(/bacca.jpg)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          mt: 6,
          borderRadius: 2,
        }}
      >
        {!showIframe && (
          <Box
            onClick={handleClick}
            sx={{
              height: 70,
              width: 120,
              backgroundColor: "#c82333",
              borderRadius: 1,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              fontWeight: "bold",
              fontSize: "1rem",
              cursor: "pointer",
              zIndex: 2,
              boxShadow: 3,
              "&:hover": {
                opacity: 0.9,
              },
            }}
          >
            <Youtube color="#FFF" size={54} />
          </Box>
        )}

        {showIframe && videoLink && (
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              zIndex: 10,
              width: { xs: "95%", sm: "90%", md: "80%", lg: "70%" },
              height: { xs: "50%", sm: "60%", md: "80%", lg: "90%" },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.9)",
              borderRadius: 2,
              boxShadow: 6,
              p: 1,
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: "100%",
              }}
            >
              <iframe
                src={videoLink}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                  borderRadius: 8,
                }}
              />
            </Box>
            <Button
              variant="contained"
              onClick={handleClose}
              sx={{
                mt: 1,
                backgroundColor: "#fff",
                color: "#000",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              {t("close")}
            </Button>
          </Box>
        )}
      </Box>
    </Container>
  );
};

export default Video;
